import type { ICellRendererParams } from 'ag-grid-community';
import type { ComponentType } from 'react';
import { Component } from 'react';

export type DetailCellRendererProps<TData = any, TExtra = undefined> = {
  cellParams: ICellRendererParams<TData>;
  extra: TExtra;
};
export function DetailCellRendererFactory<TData, TExtra>(
  FunctionComponent: ComponentType<DetailCellRendererProps<TData, TExtra>>,
  extra: TExtra,
) {
  return class DetailCellRenderer extends Component<ICellRendererParams<TData>> {
    constructor(props: ICellRendererParams<TData>) {
      super(props);
    }

    refresh(_params: unknown) {
      return true;
    }

    render() {
      return <FunctionComponent cellParams={this.props} extra={extra} />;
    }
  };
}
